/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { CreateCourseSectionOptions, CreateCourseSectionStatus200, CreateCourseSectionStatus422 } from '../models/CreateCourseSection'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createCourseSection } from '../clients/axios/createCourseSection'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createCourseSectionMutationKey = () => [{ url: '/admin/course/:course_id/sections/create' }] as const

export function createCourseSectionMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = createCourseSectionMutationKey()
  return mutationOptions<CreateCourseSectionStatus200, ResponseErrorConfig<CreateCourseSectionStatus422>, CreateCourseSectionOptions, TContext>({
    mutationKey,
    mutationFn: async({ path, body }) => {
      return await createCourseSection({ ...config, path, body, throwOnError: true })
    },
  })
}

/**
 * @summary Create Course Section
 * {@link /admin/course/:course_id/sections/create}
 */
export function useCreateCourseSection<TContext>(options: {
  mutation?: UseMutationOptions<CreateCourseSectionStatus200, ResponseErrorConfig<CreateCourseSectionStatus422>, CreateCourseSectionOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? createCourseSectionMutationKey()

  const baseOptions = createCourseSectionMutationOptions(config) as UseMutationOptions<CreateCourseSectionStatus200, ResponseErrorConfig<CreateCourseSectionStatus422>, CreateCourseSectionOptions, TContext>

  return useMutation<CreateCourseSectionStatus200, ResponseErrorConfig<CreateCourseSectionStatus422>, CreateCourseSectionOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<CreateCourseSectionStatus200, ResponseErrorConfig<CreateCourseSectionStatus422>, CreateCourseSectionOptions, TContext>
}
